import { systemIds } from '@/shared/utils';
/**
 * 单别Id
 * @param upManage 承包
 * @param subcontract 分包
 * @returns
 */
export const busCategoryId = {
    upManage: '350701382970000001',
    subcontract: '350701382970000002',
};
//合同 xjjchain-contract
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['contract'], // 为了获取基础路由
    };
};
export const contractToPathNameMap = {
    contracting1000: ({ businessKey, variables }) => {
        if (variables?.busCategoryId) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/contract/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/contract/detail?id=${businessKey}`);
            }
        }
        else {
            return commonFunc(`/contract/detail?id=${businessKey}`);
        }
    },
    contracting1010: ({ businessKey, variables }) => {
        if (variables?.busCategoryId) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/supplement/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/supplement/detail?id=${businessKey}`);
            }
        }
        else {
            return commonFunc(`/supplement/detail?id=${businessKey}`);
        }
    },
    contracting1020: ({ businessKey, variables }) => commonFunc(`/nego/detail?id=${businessKey}`),
    finance8001: () => commonFunc('/contract'),
    contracting1030: ({ businessKey, variables }) => {
        const { busType } = variables;
        if (busType == 1) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/contract/cancel/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/contract/cancel/detail?id=${businessKey}`);
            }
        }
        else if (busType == 2) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/contract/close/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/contract/close/detail?id=${businessKey}`);
            }
        }
        else if (busType == 3) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/contract/removeClose/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/contract/removeClose/detail?id=${businessKey}`);
            }
        }
        else {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/contract/removeCancel/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/contract/removeCancel/detail?id=${businessKey}`);
            }
        }
    },
    contracting2200: ({ businessKey, variables }) => {
        if (variables?.busCategoryId === busCategoryId.upManage) {
            return commonFunc(`/upManage/contract_invoice/detail?id=${businessKey}`);
        }
        else if (variables?.busCategoryId === busCategoryId.subcontract) {
            return commonFunc(`/subcontract/contract_invoice/detail?id=${businessKey}`);
        }
    },
    contracting2400: ({ businessKey }) => {
        return commonFunc(`/subcontract/reward/detail?id=${businessKey}`);
    },
    contracting2500: ({ businessKey, variables }) => {
        if (variables?.busCategoryId === busCategoryId.upManage) {
            return commonFunc(`/upManage/settlement/detail?id=${businessKey}`);
        }
        else if (variables?.busCategoryId === busCategoryId.subcontract) {
            return commonFunc(`/subcontract/settlement/detail?id=${businessKey}`);
        }
    },
    contracting2800: ({ businessKey, variables }) => {
        if (variables?.busCategoryId === busCategoryId.upManage) {
            return commonFunc(`/upManage/valuation/detail?id=${businessKey}`);
        }
        else if (variables?.busCategoryId === busCategoryId.subcontract) {
            return commonFunc(`/subcontract/valuation/detail?id=${businessKey}`);
        }
    },
    contracting2900: ({ businessKey, variables }) => {
        if (variables?.busCategoryId === busCategoryId.upManage) {
            return commonFunc(`/upManage/claim-approve/detail?id=${businessKey}`);
        }
        else if (variables?.busCategoryId === busCategoryId.subcontract) {
            return commonFunc(`/subcontract/claim-approve/detail?id=${businessKey}`);
        }
    },
    contracting2000: ({ businessKey }) => {
        return commonFunc(`/upManage/output/detail?id=${businessKey}`);
    },
    contracting2100: ({ businessKey }) => {
        return commonFunc(`/subcontract/inspect_work/detail?id=${businessKey}`);
    },
    contracting2300: ({ businessKey }) => {
        return commonFunc(`/upManage/projectSign/detail?id=${businessKey}`);
    },
    contracting2600: ({ businessKey }) => {
        return commonFunc(`/subcontract/sporadic/detail?id=${businessKey}`);
    },
    contracting2700: ({ businessKey }) => {
        return commonFunc(`/subcontract/temp/detail?id=${businessKey}`);
    },
    contracting3000: ({ businessKey, variables }) => {
        const { busType } = variables;
        if (busType == 1) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/paySearch/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/sub_coll/detail?id=${businessKey}`);
            }
        }
        else if (busType == 2) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/paySearch/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/sub_coll/detail?id=${businessKey}`);
            }
        }
        else if (busType == 3) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/other/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/sub_other/detail?id=${businessKey}`);
            }
        }
        else if (busType == 4) {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/deposit_proce/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/sub_deposit_proce/detail?id=${businessKey}`);
            }
        }
        else {
            if (variables?.busCategoryId === busCategoryId.upManage) {
                return commonFunc(`/upManage/refund/detail?id=${businessKey}`);
            }
            else if (variables?.busCategoryId === busCategoryId.subcontract) {
                return commonFunc(`/subcontract/refund/detail?id=${businessKey}`);
            }
        }
    },
};
